import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import * as io from 'socket.io-client';

@Injectable()
export class SocketService {

  private host: string = window.location.protocol + '//' + window.location.hostname + ':' + '3000' + '/scoreboard';
  socket: SocketIOClient.Socket;

  constructor() {
    let socketUrl = this.host;
    this.socket = io.connect(socketUrl);
  }

  sendTopic(topic: any) {
    this.socket.emit('settopic', topic)
  }

  messages(){
    let observable = new Observable(observer => {
      this.socket.on('message', (data) => {
        observer.next(data.message);
      });
    });
    return observable;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/socket.service.ts